import React, {Component} from "react";
import {Card} from "../ReusableComponents/HtmlComponents/HtmlComponents";
import {t} from "../../helpers/CommonHelper";
import {ATMLOCATION} from "./../../constants"
import {Map, GoogleApiWrapper, Marker, InfoWindow} from "google-maps-react";
import {FooterCommon, HeaderBeforeLogin} from "../containers/CommonComponents";
import "./BranchLocation.css"

class BranchLocation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showInfoWindow: false,
            displayedLocation: ATMLOCATION.locationList
        }
        this.searchHandler = this.searchHandler.bind();
        console.log(this.props.locationType);
        this.state.type = this.props.locationType;
    }

    componentDidMount() {
        console.log("ATM LOCATION", ATMLOCATION.locationList)
        //todo: Call api
        if ("geolocation" in navigator) {
            console.log("Available");
        } else {
            console.log("Not Available");
        }

        navigator.geolocation.getCurrentPosition(function (position) {
            console.log("POSITION", position.coords.latitude);
            console.log("POSITION LNG", position.coords.longitude);

        })

    }

    handleMouseOver = e => {
        console.log("Mouse Over")
        this.setState({showInfoWindow: true});
    }


    handleMouseExit = e => {
        console.log("Mouse exit")
        this.setState({
            showInfoWindow: false
        });
    }

    searchHandler = (event) => {
        let searchQuery = event.target.value.toLowerCase(),
            displayedLocation = ATMLOCATION.locationList.filter((element) => {
                let searchValue = element.branchBusinessAddressInEnglish.toLowerCase();
                return searchValue.indexOf(searchQuery) !== -1;
            })

        this.setState({
            displayedLocation: displayedLocation
        })
    }

    render() {
        console.log(this.props.type);
        let {displayedLocation, showInfoWindow} = this.state;
        console.log("Show info window", showInfoWindow)
        let self = this;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 vh-100 logbox-layout">
                        <HeaderBeforeLogin loginLink={true}/>
                        <div className="row  pr-3 pl-3 pb-5 pt-4 mb-5" style={{flexGrow: 1}}>
                            <div className="col-12 col-sm-10 offset-sm-1" style={{flexGrow: 1}}>
                                <h1 className="mb-4">{self.state.type} Location</h1>
                                <div className="row">
                                    <div className="max-h-screen tab-content" id="locationMapTabContent">
                                        <Map google={this.props.google}
                                             zoom={13}
                                             initialCenter={{
                                                 lat: "23.75",
                                                 lng: "90.4025"
                                             }}>

                                            {ATMLOCATION.locationList.map((eachLocation, index) => {
                                                return <Marker key={index}
                                                               title={eachLocation.branchBusinessAddressInEnglish}
                                                               position={{
                                                                   lat: eachLocation.lat,
                                                                   lng: eachLocation.lng
                                                               }} onClick={this.handleMouseOver}>
                                                    {showInfoWindow && <InfoWindow onClose={this.handleMouseExit}>
                                                        <h1>{eachLocation.branchBusinessAddressInEnglish}</h1>
                                                    </InfoWindow>}

                                                </Marker>
                                            })}
                                        </Map>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
                </div>

                <section className="search-box-wrapper">
                    <div className="container-fluid">
                        <input type="text" className="search-box" placeholder="search here.. "
                               onChange={this.searchHandler}/>
                        <hr/>
                        <div className="row">
                            <div className="col-md-12 listing-box">

                                {displayedLocation.map((eachLocation, index) => {
                                    return <div className="list-group-item" key={index}>
                                        <div className="">
                                            {eachLocation.branchBusinessAddressInEnglish}
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </section>
                <FooterCommon/>
            </div>

        )
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyCmPTW7A-wCqMPARtsZ8ZdECINihJAtBZw"
})(BranchLocation);
